<template>
	<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
		<h4 class="margin-b-16">Activiteit</h4>
		<div v-if="activities.length === 0">
			<p>Nog geen activiteiten</p>
		</div>
		<div class="c-timeline">
			<div class="c-timeline__date" v-for="(activities, key) in groupedDates">
				<div class="c-timeline__day">{{ key }}</div>
				
				<div class="c-timeline__item" v-for="activity in activities">
					<div class="c-timeline__time">{{ $filter.prettytime(activity.created_at) }}</div>
					<div class="c-timeline__title">{{activity.product?.name}} | {{activity.status?.name}}</div>
				</div>
			</div>
		</div>

		<div class="c-timeline__more" v-if="hasMore">
			<a class="c-btn c-btn--hollow c-btn--expanded no-margin" :href="'/activiteiten/leveringen/' + client_id" v-if="type == 'repair'">Meer weergeven</a>
			<a class="c-btn c-btn--hollow c-btn--expanded no-margin" :href="'/activiteiten/' + client_id" v-else>Meer weergeven</a>
		</div>

	</div>
</template>

<script>
export default {
	props: {
		activities: {
			type: Array,
			required: false
		},
		client_id : {
			required: false
		},
		max: {
			type: Number,
			required: false,
			default: 3
		},
		type: {
			type: String,
			required: false,
			default: 'crm'
		}
	},
	computed: {
		groupedDates() {

			this.activities.sort((a,b) => {
				if (a.created_at > b.created_at) {
					return -1
				}
				if (a.created_at < b.created_at) {
					return 1
				}
				return 0
			})

			return this.activities.slice(0,this.max).reduce((grouped, activity) => {

				const key = this.$filter.prettydate(activity.created_at);
				(grouped[key] ??= []).push(activity);
				return grouped;
			}, {});
		},
		hasMore() {
			return this.activities.length > this.max;
		}
	}
}
</script>
